import AccountCardAlbumCustomPrintConfigurator from './AccountCardAlbumCustomPrintConfigurator';

export default AccountCardAlbumCustomPrintConfigurator;
